import { ABOUT } from "@/data/content";

export default function SDGSection() {
  return (
    <section className="py-16 md:py-20 bg-white border-t border-slate-200/70" data-testid="home-sdg">
      <div className="container-sf">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-10">
          <div>
            <div className="eyebrow mb-3">Sustainable Development Goals</div>
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 max-w-xl leading-tight">
              Terhubung dengan agenda pembangunan global
            </h3>
          </div>
          <p className="max-w-lg text-slate-600 leading-relaxed">
            Program Sauyunan berkontribusi terhadap pencapaian 9 Tujuan Pembangunan Berkelanjutan (SDGs) PBB.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          {ABOUT.sdgs.map((s) => (
            <div
              key={s.num}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-[var(--bg)] px-4 py-2"
              data-testid={`sdg-${s.num}`}
            >
              <span className="h-7 w-7 rounded-full bg-[var(--brand-blue)] text-white text-xs font-bold flex items-center justify-center">
                {s.num}
              </span>
              <span className="text-sm font-medium text-slate-800">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
